import { createSlice } from "@reduxjs/toolkit";

export const DEFAULT_EXPENSE_DATE_BASIS = "voucher_order_date";
const DISABLED_EXPENSE_DATE_BASIS = ["payment_date"];

const sanitizeExpenseDateBasis = (value) => {
  if (!value || DISABLED_EXPENSE_DATE_BASIS.includes(value)) {
    return DEFAULT_EXPENSE_DATE_BASIS;
  }
  return value;
};

const initialState = {
  expenseDateBasis: DEFAULT_EXPENSE_DATE_BASIS,
  xmlGeneratorEnabled: false,
  xmlGeneratorConfigLoaded: false,
};

export const AppConfigSlice = createSlice({
  name: "appConfig",
  initialState,
  reducers: {
    SET_EXPENSE_DATE_BASIS: (state, action) => {
      state.expenseDateBasis = sanitizeExpenseDateBasis(action.payload);
    },
    SET_XML_GENERATOR_ENABLED: (state, action) => {
      const value = action.payload;
      state.xmlGeneratorEnabled =
        value === true || value === 1 || value === "1";
      state.xmlGeneratorConfigLoaded = true;
    },
  },
});

export const { SET_EXPENSE_DATE_BASIS, SET_XML_GENERATOR_ENABLED } =
  AppConfigSlice.actions;
export default AppConfigSlice.reducer;
